import { render, staticRenderFns } from "./AssignWorkServiceLog.vue?vue&type=template&id=9d391f0c&scoped=true&"
import script from "./AssignWorkServiceLog.vue?vue&type=script&lang=ts&"
export * from "./AssignWorkServiceLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d391f0c",
  null
  
)

export default component.exports